import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { change } from 'redux-form';
import {
  Container,
  DpsForm,
  EmitChargesInformationForm,
  EmitContactInformationForm,
  EmitPersonalInformationForm,
  HeaderProcess,
  PaymentForm,
} from '../components/';
import { IEmitForm, submitEmitForm } from '../store/Emit';
import { IPlan } from '../store/Quote';
import { env } from '../env';

interface IProposalProps {
  changePaymentMethod: (method: string) => void;
  emit: (payload: IEmitForm) => void;
  back: () => void;
  fullName: string;
  initialValues: any;
  charges: string;
  planSelected: IPlan;
  emitting: boolean;
}

export function Emit(props: IProposalProps) {
  const {
    back,
    changePaymentMethod,
    charges,
    emit,
    fullName,
    initialValues,
    planSelected,
    emitting,
  } = props;
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvPlanSelected',
          producto: `${planSelected.name} | ${planSelected.planName}`,
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      // Funnel step viewed
      ReactGA.event('user_interaction', {
        "action": planSelected.plan_id === 'VML5PA' ? 'ambulatorio-50' : planSelected.plan_id === 'VML7PA' ? 'ambulatorio-70': planSelected.plan_id === 'VML5PF' ? 'full-50': planSelected.plan_id === 'VML7PF' ? 'full-70' : '',
        "location": "paso-cotizacion",
        "flow": "salud-complementario"
      });
    }
  }, [planSelected]);

  const nextPage = () =>
    charges === '0' && page === 2 ? setPage(4) : setPage(page + 1);

  const previousPage = () =>
    charges === '0' && page === 4 ? setPage(2) : setPage(page - 1);

  return (
    <Container>
      <HeaderProcess stage={page} />
      <div className="container mb50 subscription">
        <div className="row justify-content-center">
          <div className="col-12">
            {page === 1 && (
              <EmitPersonalInformationForm
                onSubmit={nextPage}
                back={back}
                initialValues={initialValues}
              />
            )}
            {page === 2 && (
              <EmitContactInformationForm
                onSubmit={nextPage}
                previousPage={previousPage}
                initialValues={initialValues}
              />
            )}
            {page === 3 && (
              <EmitChargesInformationForm
                onSubmit={nextPage}
                previousPage={previousPage}
                charges={charges}
              />
            )}
            {page === 4 && (
              <DpsForm onSubmit={nextPage} previousPage={previousPage} />
            )}
            {page === 5 && (
              <PaymentForm
                changePaymentMethod={changePaymentMethod}
                documentId={initialValues.documentId}
                fullName={fullName}
                onSubmit={emit}
                plan={planSelected}
                previousPage={previousPage}
                emitting={emitting}
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      data: { birthdate, email, phone, documentId, charges },
      planSelected,
    },
    Emit: { emitting },
    form,
  } = state;

  const formValues =
    (form.proposal && form.proposal.values && form.proposal.values) || {};
  const fullName = `${formValues.name || ''} ${formValues.paternal || ''}`;
  const { province, region } = formValues;

  return {
    charges,
    emitting,
    fullName,
    initialValues: {
      birthdate,
      charges,
      declarationCard: false,
      documentId,
      email,
      paymentMethod: 'OTHERS',
      phone,
      province,
      region,
    },
    planSelected,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  changePaymentMethod: (method: string) =>
    dispatch(change('proposal', 'paymentMethod', method)),
  emit: (payload: IEmitForm) => {
    payload.phone = payload.phone.replace(/ /gi, '');
    dispatch(submitEmitForm(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Emit);
